import React from "react";
import PropTypes from "prop-types";
const ShareArrowIcon = ({
  width,
  size,
  height,
  style,
  color,
  noPointer,
  title,
  ...props
}) => (
  <svg
    {...props}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fillRule="nonzero"
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1.047 15c-.031-.018-.047-.036-.047-.072.436-2.62 1.291-4.81 2.52-6.497C5 6.403 7.007 5.146 9.497 4.715V1.054c0-.018.015-.036.03-.054.016 0 .047 0 .047.018l5.415 6.48c.016.017.016.053 0 .09l-5.399 6.46c-.016.019-.031.019-.047.019-.015 0-.03-.036-.03-.054v-3.734c-3.828.018-6.505 1.508-8.403 4.703-.031.018-.047.018-.062.018z"
      />
    </g>
  </svg>
);
ShareArrowIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default ShareArrowIcon;
